import { AgGridReact } from "ag-grid-react";
import { forwardRef, useMemo } from "react";
import K from "../../../utilities/constants";
import { useDataGrid } from "../../../hooks/useDataGrid/useDataGrid";
import { LoadingOverlay } from "./loadingOverlay";

export const ServerSideDataGrid = forwardRef(
  (
    {
      userId,
      configKey,
      getData,
      defaultColumnConfig,
      onDataFetchSuccess,
      onDataFetchFailed,
      useGlobalLoading = true,
      showTableLoadingOverlay = false,
      useCustomLoader = false,
      ...props
    },
    ref,
  ) => {
    const gridParams = useDataGrid(
      userId,
      configKey,
      defaultColumnConfig,
      useGlobalLoading,
    );

    const dataSource = useMemo(() => {
      return {
        getRows: async (params) => {
          const { startRow, endRow, sortModel, filterModel } = params.request;

          const pageSize = endRow - startRow;
          const page = startRow / pageSize + 1;

          const body = {
            page,
            pageSize,
            sortBy: sortModel[0]?.colId,
            sortOrder: sortModel[0]?.sort,
            filterBy: Object.keys(filterModel)[0],
            filterValues: Object.values(filterModel)[0]?.values,
          };

          try {
            if (showTableLoadingOverlay) {
              params.api.showLoadingOverlay();
            }

            const res = await getData(body);

            if (!res.total) {
              params.api.showNoRowsOverlay();
            } else {
              params.api.hideOverlay();
            }

            const data = { rowData: res.data, rowCount: res.total };
            params.success(data);
            onDataFetchSuccess?.(data);
          } catch (err) {
            if (showTableLoadingOverlay) {
              params.api.hideOverlay();
            }
            params.fail();
            onDataFetchFailed?.(err);
          }
        },
      };
    }, [
      getData,
      onDataFetchSuccess,
      onDataFetchFailed,
      showTableLoadingOverlay,
    ]);

    return (
      <div
        className="ag-theme-alpine s2-theme-style"
        style={{
          height: props.height || 735,
          minHeight: props.minHeight,
        }}
      >
        <AgGridReact
          {...K.AgGridTable.DefaultProps}
          {...gridParams}
          {...props}
          ref={ref}
          serverSideDatasource={gridParams.columnDefs ? dataSource : null}
          rowModelType="serverSide"
          cacheBlockSize={props.paginationPageSize || gridParams.cacheBlockSize}
          {...(useCustomLoader && {
            loadingOverlayComponent: LoadingOverlay,
          })}
        />
      </div>
    );
  },
);
